import classNames from "classnames";
import React from "react";
import _ from 'lodash'
import { Button } from 'primereact/button';
import {Chip} from "primereact/chip";
import {FIELD_TYPES, isComputedType} from "../data";
import {getAPIVersion} from "../helpers/getAirtableMetaAPIVersion";
import {DateTime} from 'luxon';
import numeral from 'numeral';
import {Divider} from "primereact/divider";
import {convertMDToHTML} from "../helpers/convertMDToHTML";
import parse from "html-react-parser";
import {Card} from "primereact/card";
import cls from "./RecordSearch/search.module.scss";
import {AppState} from "../@redux";
import {convertTemplate} from "../helpers/templater";
import {getDisplayFields, getSearchFields} from "./AirtableFields/RecordLinks/search.common";
import DOMPurify from 'dompurify';
import { Toolbar } from 'primereact/toolbar';
import { Image } from 'primereact/image';
import { Badge } from 'primereact/badge';
import parseCss from "style-to-js";
import {Avatar} from 'primereact/avatar';
import {Collab} from "../types/formPage";
import {Tooltip} from "primereact/tooltip";
import {v4 as uuid} from 'uuid';
import {storeFormData} from "../helpers/formPage";
import {calculateFormula} from "../helpers/formulas";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Calendar} from "primereact/calendar";
import {TriStateCheckbox} from "primereact/tristatecheckbox";

export const FieldTypes = FIELD_TYPES(getAPIVersion())
export const wrapComponent = ( input, extra) => {
    // const {group = {before: {content: "First Name:", bgColor: 'red-500', color: 'gray-50'}, after: {content: 'pi-search', bgColor: 'yellow-500'}}, icon = {content: 'pi-search', location: 'left'}} = extra
    const {group, icon} = extra
    const groupStyle = g => ({backgroundColor: g.bgColor ? `var(--${g.bgColor})` : undefined, color: g.color ? `var(--${g.color})` : undefined})
    return (group?.before?.content || group?.after?.content) ?
        (
            <div className="p-inputgroup">
                {group.before?.content ? <span className="p-inputgroup-addon" style={ groupStyle(group.before) }>
    <i className={classNames('pi', group.before.content.startsWith('pi-') ? group.before.content : '')}>{group.before.content.includes('pi-') ? '' : group.before.content}</i>
    </span> : ''}
    {input}
    {group.after?.content ? <span className="p-inputgroup-addon" style={ groupStyle(group.after)}>
        <i className={classNames('pi', group.after.content.startsWith('pi-') ? group.after.content : '')}>{group.after.content.includes('pi-') ? '' : group.after.content}</i>
    </span> : ''}
    </div>
    ) : (icon?.content) ?
        (<span className={`p-input-icon-${icon.location || 'left'}`}>
        <i className={classNames('pi', icon.content.includes('pi-') ? icon.content : '')} >{icon.content.includes('pi-') ? '' : icon.content}</i>
        {input}
        </span>) : input


}
export const asIcon = (name, text, on = false, onClick = null, disabled = false) => {
    const id = uuid()
    return (

            <div
                style={{ cursor: disabled ? '' : 'pointer', opacity: disabled ? 0.5 : 1 }}
                onClick={disabled || _.isString(onClick) ? null : onClick}
            >
                <Tooltip target={`.tt-${id}`}/>
                    {_.isString(onClick) ? (
                        <a href={onClick} target={'_blank'} rel="noreferrer">
                            {' '}
                            <i className={`pi pi-${name} tt-${id}`} data-pr-tooltip={text} style={{fontSize: 12, color: on ? 'blue' : 'black'}} />
                        </a>
                    ) : (
                        <i className={`pi pi-${name}  tt-${id}`} data-pr-tooltip={text} style={{fontSize: 12, color: on ? 'blue' : 'black'}} />
                    )}
            </div>

    )
}
export const extract = (map, config, merge = {}, prioritizeMerge = false, renameMap = {}) => {
    if(Array.isArray(map)){
        map = _.reduce( map, (result, value) => {
            result[value] = undefined
            return result
        }, {})
    }
    const use = _.pick( config, Object.keys(map))
    _.each(map, (val,key) => {

        if(!_.has(use, key) && val !== undefined)use[key] = val

    })
    const after = prioritizeMerge ? {...use, ...merge} : {...merge, ...use}
    const removals = ['hasError', 'details']
    for(const removal of removals)_.unset( after , removal)
    _.each(renameMap, (rmVal, rmKey) => {
        if(_.has(after,rmKey)){
            after[rmVal as any] = after[rmKey] as any
            delete after[rmKey]
        }
    })
    if(after['style'] && _.isString(after['style']))after['style'] = toStyle(after['style'])
    return after
}

export const _isBlank = (val:any, boolVal = false ) => {
    switch (typeof val){
        case 'boolean':
            return boolVal ? !val : false
        case 'function':
            return false
        case 'number':
            return isNaN(val)
        default:
            if(_.isPlainObject(val) || _.isArray(val))return _.isEmpty(val)
            return !val
    }
}


export const choiceColorMap = {
    blueLight2: ['#cfdfff','#102046'], cyanLight2: ['#d0f0fd','#04283f'], tealLight2: ['#c2f5e9','#012524'], greenLight2: ['#d1f7c4','#0b1d05'],
    yellowLight2: ['#ffeab6','#3b2501'], orangeLight2: ['#fee2d5','#6b2613'], redLight2: ['#ffdce5','#4c0c1c'], pinkLight2: ['#ffdaf6','#400832'],
    purpleLight2: ['#ede2fe','#280b42'], grayLight2: ['#eeeeee','#040404'], blueLight1: ['#9cc7ff','#102046'], cyanLight1: ['#77d1f3','#04283f'],
    tealLight1: ['#72ddc3','#012524'], greenLight1: ['#93e088','#0b1d05'], yellowLight1: ['#ffd66e','#3b2501'], orangeLight1: ['#ffa981','#6b2613'],
    redLight1: ['#ff9eb7','#4c0c1c'], pinkLight1: ['#f99de2','#400832'], purpleLight1: ['#cdb0ff','#280b42'], grayLight1: ['#cccccc','#040404'],
    blueBright: ['#2d7ff9','#ffffff'], cyanBright: ['#18bfff','#ffffff'], tealBright: ['#20d9d2','#ffffff'], greenBright: ['#20c933','#ffffff'],
    yellowBright: ['#fcb400','#ffffff'], orangeBright: ['#ff6f2c','#ffffff'], redBright: ['#f82b60','#ffffff'], pinkBright: ['#ff08c2','#ffffff'],
    purpleBright: ['#8b46ff','#ffffff'], grayBright: ['#666666','#ffffff'], blueDark1: ['#2750ae','#cfdfff'], cyanDark1: ['#0b76b7','#d0f0fd'],
    tealDark1: ['#06a09b','#c2f5e9'], greenDark1: ['#338a17','#d1f7c4'], yellowDark1: ['#b87503','#ffeab6'], orangeDark1: ['#d74d26','#fee2d5'],
    redDark1: ['#ba1e45','#ffdce5'], pinkDark1: ['#b2158b','#ffdaf6'], purpleDark1: ['#6b1cb0','#ede2fe'], grayDark1: ['#444444','#eeeeee'],
}
export const colorOption = ( index: number|boolean = true ) => {
    const options = Object.values(choiceColorMap)
    const ran = Math.floor(Math.random() * options.length )
    return index === true ? choiceColorMap
        : _.get( options, index === false ? ran : index )
}
export const getAttachmentUrl = (att, paths) => {
    // eslint-disable-next-line
    for (const path of paths) {
        const url = _.get(att, path);
        if (url) return url;
    }
    return '';
};
export const toPixel = (amount , defaultAmt) => amount ? (_.isNumber(amount) ? `${amount}px` : amount) : defaultAmt
export const convertColor = (color, defaultColors = null) => {

    return choiceColorMap[color] ?? defaultColors ?? choiceColorMap.blueLight2
}
export const toChip = (use_color, options = [], def = {value: 'name', label: 'name', onRemove: null}, customRender = null) => function toChipColor(option){
    if(option){
        const renderChip = (label, style={}) => {
            return (
                <div className={`p-multiselect-token ${def.onRemove ? '' : 'pl-2 pr-2'}`} key={label} style={style}>
                    <span className="p-multiselect-token-label">{label}</span>
                    {def.onRemove && <i className={'p-multiselect-token-icon pi pi-times-circle'} onClick={(e) => {
                        e.preventDefault()
                        if(def.onRemove)def.onRemove(option[def.value])
                    }}/>}
                </div>
            )
        }
        if(_.isString(option))option = options.find( o => o[def.value] === option) || {[def.value]: option, [def.label]: option}
        if(use_color){
            const [backgroundColor, color] = convertColor(option.color)
            return (customRender && option.custom) ? customRender(option, def) : renderChip(option[def.label], {backgroundColor, color})
        }else{
            return (customRender && option.custom) ? customRender(option, def) : renderChip(option[def.label])
        }
    }

    return <span className={classNames('p-dropdown-label', 'p-inputtext' ,'p-dropdown-label-empty')}>empty</span>

}
export const emptySelectTemplate = ( extraConfig, onClick ) => {
    const {allow_create = true, emptyFilterMessage = 'No results found'} = extraConfig
    return allow_create ? (
        <Button
            onClick={onClick}
        >
            Create as New Option
        </Button>
    ) : emptyFilterMessage
}
export const toDivider = ( divider:any = {}, defaultDivider:any= <br/> ) => {
    return _.isEmpty(divider) ? defaultDivider : _.isString(divider) ? renderValue(divider) : <Divider {...divider}/>
}
export const checkLen = (label, len = 30) => (label.length > len ? label.substring(0, len) + '...' : label)
export const markDisplay = (value, searchText = '') => {
    try {
        return searchText ? `${[undefined,null].includes(value) ? '' : value}`.replace(/(<([^>]+)>)/ig, '').replace(new RegExp(`(${searchText})`, 'gi'), '<mark>$1</mark>')
            : value
    } catch (mdIgnore) { }
    return value
}
export const prepPrecisionFormat = (format, options, ifNoOptions = null) => {
    if(options?.precision){
        switch(options?.precision){
            case 0:
                format = format.replace('.00','')
                break;
            default:
                format = format.replace('.00','.' + _.repeat('0',options.precision))
        }
        return format
    }
    return ifNoOptions || format
}
export const fieldDefaultConfig = (env:string, type:string, options:any, config:any = {}) => {
    const def = {
        render_as:'plain',format_as:'plain', display_as: 'plain', format: '',
        display_mode: isComputedType(FieldTypes.SOURCE, type) ? 'edit' : 'edit',
        always_display: false,
        table:{
            filterType: 'text', dataType: 'text',
            sortable:false,
            filter:false,
            filterMatchMode: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            filterElement: undefined,
        }
    }
    const tableFilterElement = (filterType, elemOptions = {}) => {
        switch(filterType){
            case 'date':
            case 'datetime': {
                const tableFilter = (filtOptions) => {
                    return (
                        <Calendar
                            value={filtOptions.value}
                            onChange={(e) => filtOptions.filterCallback(e.value, filtOptions.index)}
                            dateFormat={(config.format || def.format).replace('yyyy','yy')}
                            placeholder={config.format || def.format}
                            showTime={filterType === 'datetime'}
                        />
                    );
                }
                return tableFilter
                break;
            }

            case 'checkbox':{
                const tableFilter = (filtOptions) => {
                    return (
                        <>
                        <TriStateCheckbox
                            value={filtOptions.value}
                            onChange={(e) => filtOptions.filterCallback(e.value)}
                        /><p>{' '}{options.title || options.name}</p>
                        </>
                    );
                }
                return tableFilter
                break;
            }
        }
        return undefined
    }

    switch(type){

        case FieldTypes.FT_DATE:
            def.format = 'mm/dd/yyyy'
            def.format_as = 'date'
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'date'
            def.table.dataType = 'date'
            def.table.filterElement = tableFilterElement('date')
            break;
        case FieldTypes.FT_DATETIME:
            def.format = 'mm/dd/yyyy h:mm a'
            def.format_as = 'date'
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'datetime-local'
            def.table.dataType = 'date'
            def.table.filterElement = tableFilterElement('datetime')
            break;
        case FieldTypes.FT_CREATED:
        case FieldTypes.FT_LAST_MODIFIED:
            def.format = 'mm/dd/yyyy h:mm a'
            def.format_as = 'date'
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'date'
            def.table.dataType = 'date'
            def.table.filterElement = tableFilterElement('date')
            break;
        case FieldTypes.FT_NUMBER:
            def.format = config?.mode === 'currency' ? prepPrecisionFormat('$0,00.00', options): prepPrecisionFormat('0,0.00', options, '0,0')
            def.format_as = 'number'
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'number'
            def.table.dataType = 'numeric'
            break;
        case FieldTypes.FT_COUNT:
        case FieldTypes.FT_AUTONUMBER:
            def.format = '0,0'
            def.format_as = 'number'
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'number'
            def.table.dataType = 'numeric'
            break;
        case FieldTypes.FT_PERCENT:
            def.format = '0.00%'
            def.format_as = 'number'
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'number'
            def.table.dataType = 'numeric'
            break;
        case FieldTypes.FT_CURRENCY:
            def.format = prepPrecisionFormat('$0,00.00',options)
            def.format_as = 'number'
            if(options?.symbol && options?.symbol !== '$'){
                //??? how to determine location?
            }
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'number'
            def.table.dataType = 'numeric'
            break;
        case FieldTypes.FT_RATING:
            def.format_as = 'rating'
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'number'
            def.table.dataType = 'numeric'
            break;
        case FieldTypes.FT_RECORD_LINKS:
            def.format_as = 'template'
            def.render_as = 'record'
            def.display_as = env === 'table' ? 'plain' : 'list'
            break;
        case FieldTypes.FT_ATTACHMENTS:
            def.format_as = 'attachment'
            // if(['search'].includes(env))def.format_as = 'url'
            def.render_as = 'attachment';
            def.display_as =  'attachment';//env === 'table' ? 'gallery' : (env === 'linked_display' ? 'carousel' : 'gallery');
            break;
        case FieldTypes.FT_DURATION:
            def.format_as = 'duration'
            def.table.filter = def.table.sortable = true
            def.table.dataType = 'numeric'
            break;
        case FieldTypes.FT_CHECKBOX:
            def.format_as = 'boolean'
            def.render_as = 'checkbox';
            def.display_as = 'switch';
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'checkbox'
            def.table.dataType = 'boolean'
            def.table.filterElement = tableFilterElement('checkbox')
            break;
        case FieldTypes.FT_SINGLE_COLLAB:
        case FieldTypes.FT_MULTI_COLLABS:
            def.format_as = 'collaborator'
            def.render_as = 'collaborator'
            def.table.filter = def.table.sortable = true
            break;
        case FieldTypes.FT_CREATED_BY:
        case FieldTypes.FT_LAST_MODIFIED_BY:
            def.format_as = 'collaborator'
            def.render_as = 'collaborator'
            def.table.filter = def.table.sortable = true
            def.table.filterType = 'date'
            def.table.dataType = 'date'
            break;
        case FieldTypes.FT_BUTTON:
            def.format_as = 'button';
            def.render_as = 'button';
            break;
        case FieldTypes.FT_SINGLE_SELECT:
            def.render_as = 'pill';
            def.table.filter = def.table.sortable = true
            break;
        case FieldTypes.FT_MULTI_SELECTS:
            def.render_as = 'pill';
            def.table.filter = def.table.sortable = true
            break;
        case FieldTypes.FT_LOOKUP: {
            const lookupOptions = options || config.options
            if (lookupOptions?.lookupFieldType) {
                return fieldDefaultConfig(env, lookupOptions.lookupFieldType, lookupOptions.lookupFieldOptions, config)
            }
            break;
        }
        case FieldTypes.FT_ROLLUP:
        case FieldTypes.FT_FORMULA: {
            const innerOptions = options || config.options
            if (innerOptions?.result?.type) {
                return fieldDefaultConfig(env, innerOptions?.result?.type, innerOptions?.result?.options, config)
            }
            def.table.filter = def.table.sortable = true
            break;
        }
        case FieldTypes.FT_RICH_TEXT:
            def.render_as = 'markdown';
            def.table.filter = true
            break;
        case FieldTypes.FT_SINGLE_LINE:
        case FieldTypes.FT_EMAIL:
        case FieldTypes.FT_URL:
        case FieldTypes.FT_MULTI_LINES:
        case FieldTypes.FT_PHONE:
        case FieldTypes.FT_BARCODE:
            def.table.filter = def.table.sortable = true
            break;
        case FieldTypes.CUSTOM_TEXT:
            def.render_as = 'markdown'
            def.format_as = 'markdown'
            def.display_as = 'content'
            def.always_display = true
            def.table.filter = true
            break;
        case FieldTypes.CUSTOM_FORMULA:
            def.format_as = 'text';
            def.format = config?.mode === 'currency' ? '$0,00.00': '0,0'
            def.display_as = 'formula'
            def.always_display = true
            def.table.filter = def.table.sortable = true

            break;
        case FieldTypes.CUSTOM_GOOGLE_FILE:
            def.display_as = 'google'
            def.always_display = true
            break;
        case FieldTypes.CUSTOM_EMBED:
            def.display_as = 'embed'
            def.always_display = true
            break;
        case FieldTypes.CUSTOM_SPACER:
            def.display_as = 'text'
            def.always_display = true
            break;
        case FieldTypes.CUSTOM_GPT:
            def.display_as = 'text'
            def.always_display = true
            break;
        case FieldTypes.CUSTOM_LINKED_FIELD_DISPLAY:
            def.display_as = "linked_field_display"
            def.always_display = true
            break;
    }

    return def
}

export const getRFDOptions = (defs, config) => {
    const useDef = (conf, def) => (conf && conf !== 'standard') ? conf : def
    let format_as = useDef(config.format_as, defs.format_as)
    let render_as = useDef(config.render_as, defs.render_as)
    let display_as = useDef(config.display_as, defs.display_as)
    let always_display = config.always_display ?? defs.always_display
    const renderFormatMap = {
        button: 'button',
        record: 'record',
        collaborator: 'collaborator'
    }
    _.each(renderFormatMap, (rend, form) => {
        if(format_as === form && render_as === 'standard'){
            render_as = rend
        }
    } )
    return {format_as, render_as, display_as, always_display}
}
export const parseCollab = val => {
    if(_.isPlainObject(val))return val
    let [name,email = '', profilePicUrl = '', id=''] = (val || '').split('|')
    if(name.includes('@')){
        const tmp = email
        email = name
        name = tmp
    }
    if(!id)id = email || name
    return {id,name,email, profilePicUrl}

}
export const parseUrlLabel = val => {
    if(_.isPlainObject(val))return val
    let [url, label = ''] = (val || '').split('|')
    label = label || url
    return {url,label}
}

export const prepCustomFieldRecord = (env, details, record:any, field:any, fields: any[]) => {
    for(let f of fields){
        if(f.id !== field.id && f.type.startsWith('custom_')){
            const hasVal = formatCustomValue(env, details, f.type, f, record)
            if(hasVal !== null){
                record[f.id] = hasVal
            }
        }
    }
    return record
}

export const formatCustomValue = (env:string, details:any, type:string, config:any, record = null, render = false) => {

    switch(type){
        case FieldTypes.CUSTOM_TEXT: {
            const { template = {}} = config
            const {content = '', render_as = ''} = template
            const formData = record ?? insertRecordFormData( details.instance, null, details.store, true, false )
            const temp = renderTemplate( content, formData,{render_as: render_as || 'markdown',...config})

            console.log('*text_formatCustomValue*',{content,record,details,formData,temp,config})
            return render ? renderValue(temp.output, config) : temp.output
            break;
        }
        case FieldTypes.CUSTOM_FORMULA:{
            const formData = record ?? insertRecordFormData( details.instance, null, details.store, true, false )
            console.log('**formatCustomValue**', {env,details,type,config,formData, record})
            const {formula = '', format_as = 'text'} = config
            let path = [...details.path]
            if(record?.tableRecordId)path.push(record?.tableRecordId)
            const answer = calculateFormula('field',details.store,  format_as,formula,path,formData,config)

            return render ? renderValue( answer.result, config ) : answer.result
            break;
        }
    }
    return null
}
export const formatValueWithCustom = (env:string, value:any, config:any, details:any, record = null ) => {
    return config.type?.startsWith('custom_') ? formatCustomValue( env, details, config.type, config, record) : formatValue( env, value, config )
}
export const formatValue = ( env:string, value:any, config:any, log = false) => {
    const { type, array_separator = ',' } = config
    let { format_as, template, format, raw = false } = config
    const ori = value
    const defs = fieldDefaultConfig(env, type, config.options, config)
    if(!format_as || format_as === 'standard')format_as = defs.format_as
    if(!format || format === 'standard')format = defs.format

    if(!template)template = ''
    const convert = ( val ) => {

        if(format_as === 'number'){
            if(raw) {
                val = isNum(val,true,true)
            }else{
                const {locale = null, zeroFormat = null, nullFormat = null} = config
                val = formatNumber(val, format || '0,0', locale, zeroFormat, nullFormat)
            }
        }else if( format_as === 'date'){
            const {locale = null} = config

            const time = type === FieldTypes.FT_DATETIME
            if(raw) {
                val = isDate(val,true)
            }else {
                val = toDateText(val, _.isObject(format) ? {time, ...format} : {
                    time,
                    format: format || (time ? 'L LT' : 'L'),
                    locale
                })
            }
            console.log('Formating Date Field', {raw,ori,val, config, format})
        }else if( format_as === 'rating'){
            const {emoji = "⭐", emoji_on = "", emoji_off = "✰", stars = 5} = config
            const count = Number(`${val}`)
            if(raw) {
                val = count
            }else {

                val = ''
                for (let x = 0; x < count; x++) val += emoji_on || emoji
                if (stars && emoji_off) for (let y = count; y < stars; y++) val += emoji_off
            }
        }else if( format_as === 'url'){
            if(_.isObject(val)){
                const {url_path: path} = config
                const map = {
                    small: 'thumbnails.small.url',
                    large: 'thumbnails.large.url',
                    full: 'thumbnails.full.url',
                }
                val = _.get(val, map[path] || path || 'url' )
            }
        }else if(format_as === 'duration'){
            if(raw) {
            }else {
                val = formatDuration(val, format)
            }
        }else if(['boolean','bool','toggle'].includes(format_as)){
            const {onLabel = 'ON', offLabel = 'OFF'} = config
            const isSet = [true,'on','yes',1,'1','true'].includes(val)
            if(raw) {
                val = isSet
            }else {
                val = isSet ? onLabel : offLabel
            }
        }else if(format_as === 'button') {
            if(raw) {
                return pluckFirst(val,['label', 'value', 'name', 'url', 'id', 'error'])
            }else {
                if (_.isObject(val) as any) {
                    return val
                } else if (_.isString(val)) {
                    return parseUrlLabel(val)
                }
            }
        }else if(format_as === 'collaborator') {
            if(raw) {
                return pluckFirst(val,['label', 'value', 'name', 'email', 'url', 'id', 'error'])
            }else {
                if (_.isObject(val) as any) {
                    return val
                } else if (_.isString(val)) {
                    return parseCollab(val)
                }
            }
        }else if(format_as === 'attachment'){
            if(raw) {
                return pluckFirst(val,[ 'url','label', 'value', 'name', 'email', 'id', 'error'])
            }else {
                return toAttachment(val)
            }
        }else if( ['template','plain'].includes(format_as) && !template && _.isObject(val) ){
            return pluckFirst(val,['label','value','__','name','url','id','error'])

        }
        if( template ){
            if(_.isObject(val)){
                let newVal = template
                _.each( val, (vVal, vKey) => newVal = newVal.replace(new RegExp(`{{${vKey}}}`, 'gi'), vVal) )
                newVal = newVal.replace(/{{VALUE}}/g, pluckFirst(val,['label','value','__','name','url','id','error']))
                val = newVal
            }else{
                val = template.replace(/{{VALUE}}/g, val)
            }
        }
        return val

    }
    if(_.isArray(value) && format_as !== 'json'){
        _.each(value, (val,key) => value[key] = convert(val) )
        if(array_separator)value = value.join(array_separator)
    }else{
        if(log)console.log('Converted Format Value Before', format_as, value)
        value = convert(value)
        if(log)console.log('Converted Format Value After', format_as, value)
    }

    return value
}

export const pluckFirst = (item, keys, arrayJoin = ', ') => {
    if(Array.isArray(item))return item.map( i => pluckFirst(i,keys,arrayJoin)).join(arrayJoin)
    if (_.isObject(item) as any) {
        if(_.isEmpty(item))return ''
        for (let key of keys) {
            if (_.has(item, key)) return item[key]
        }
        return pluckFirst(item,Object.keys(item),arrayJoin)
    }
    return item
}

export const toAttachment = (att:any) => {

    if(_.isString(att)) {
        let url = new URL(att)
        let filename = url.pathname.split('/').reverse()[0]
        let ext = filename.split('.').pop()
        let attachment = {
            id: `${Date.now()}`,
            url: att,
            filename, ext
        }
        return attachment
    }else if(_.isObject(att as any) && !att.id && !att.ext && att.url){
        return toAttachment(att.url)
    }
    return att
}

export const parseFieldValue = (field, val, key = '') => {
    if(Array.isArray(val)){
        return val.map( v => parseFieldValue(field,v, key) )//.join(',')
    }else if(_.isDate(val)){
        return field.type === FieldTypes.FT_DATE ? val.toLocaleDateString() : val.toLocaleString()
    } else if(_.isPlainObject(val)){
        const doKeys = (keys) => {
            for(let useKey of keys){
                if(useKey && _.has(val,useKey))return _.get(val,useKey)
            }
            return null
        }
        if(key){
            //see if its there
            if(_.has(val,key))return _.get(val,key)
            //look for alternate
            const display_fields = _.get(field,'display_fields.fields') || []
            const match = display_fields.find( df => [df.id,df.name,df.column_header].includes(key))
            if(match){
                return doKeys([match.column_header, match.name, match.id])
            }
        }
        console.log('Parsing Field Value', field, key,val, typeof val)
        const baseKeys = ['value','name','id']
        return doKeys(baseKeys)
    }
    return val

}


export const renderRecordField = (env:string, initFieldInfo, record, location, state:any = {}) => {
    console.log('Rendering Secondary Field', location, initFieldInfo, state, record)
    const fieldInfo = {...(initFieldInfo || {})}
    const {selected = false,showCheck= true, details} = state
    let {value = null} = state
    const selectedRec = location === 'primary' && selected
    const showSelectedRec = selectedRec && showCheck ? (
        <></>
        // <i className="pi pi-check font-weight-500"
        //    style={{  color: '#2196f3', position: 'relative', top: '-25px' }}
        // />
    ) : ''
    if(value === null) value = renderValue( formatValueWithCustom( env, record[fieldInfo.name] , fieldInfo, details, record ), fieldInfo )
    console.log("**renderRecordField**", {value,state,env,fieldInfo, record,location})
    if(location === 'primary') {
        return (
            <>
                {showSelectedRec}
                <div className={`${cls.recordName} flex text-3xl text-800`} style={ {overflowX: 'hidden', width: '100%', height: '40px'}}>{value || '\u00A0'}</div>
                </>
        )
    }else if(location === 'secondary') {

        return (
            <div className={`${cls.recordDescription} pb-2 text-lg text-500`} style={ {overflow: 'hidden', width: '100%', height: '50px'}}>{value || ' '}</div>
        )
    }else if(location === 'sub'){
        console.log('SUB FIELD', value, env, record[fieldInfo.name], fieldInfo, state)
        const label = fieldInfo?.column_header || fieldInfo?.name
        const len = Math.max(label?.length, `${value || ''}`?.length)
        const width = len >= 25 ? '250px' : (len >= 15 ? '200px' : (len >= 10 ? '150px' : '100px'))
        return (
            <div
                className={`flex flex-initial flex-shrink-0 len-${len}`}
                style={{width,height: "150px"}}>
                <div className={"flex flex-column "} style={{width:'100%'}}>
                    <div style={{width: '100%'}} className={"flex border-round align-items-center justify-content-center bg-gray-500 font-bold text-white"}>{label}</div>
                    <div className={"flex truncate justify-content-center vertical-align-baseline"} style={ {overflowX: 'hidden', width: '100%', height: '50px'}}>{value}</div>
                </div>
            </div>
        )
    }
}
export const recordFieldByLocation = (location, config) => {
    const fields = getDisplayFields(config)
    let field = _.find(fields, rf => rf.location === location)
    if(location === 'primary' && !field)field = _.first(fields)
    return field
}
export const renderRecord = (env: string, record:any, config:any, state:any = {}) => {
    const {layout = 'list', highlight = true, selected = false,render = renderRecordField, onClick, onClear, store, details} = state
    const FieldType = FIELD_TYPES(getAPIVersion())
    const { search:searchOptions = {} , multiple = false, showClear = false, showImage = true} = config
    const {card_height, num_cols = null, } = searchOptions
    const {showButton = true, showCheck = multiple} = config
    const renderFields = getDisplayFields(config)
    let primaryField = recordFieldByLocation( 'primary', config)
    let secondaryField = recordFieldByLocation( 'secondary', config)
    let imageField = recordFieldByLocation( 'image', config)
    let subFields = _.filter(renderFields, rf => ![primaryField?.id,secondaryField?.id,imageField?.id].includes(rf.id))
    let imageFieldData = imageField ? record[imageField.name] : []
    let image = _.isObject(imageFieldData) ? _.get(imageFieldData, '0.thumbnails.large.url', _.get(imageFieldData, '0.url' ) ) : imageFieldData
    console.log("Render Record",renderFields,config, state,multiple, showCheck, record, imageField, primaryField)
    const colNum = layout === 'list' ? 12 : ( num_cols ? 12 / num_cols : 3)


    const renderOpts = {selected, showCheck, store, details}


    const renderCard = () => {
        const useImage = showImage && imageField
        const cardHeightTop = useImage || secondaryField ? 100 :  50
        const cardHeightUse = card_height ? card_height : cardHeightTop + ( subFields.length ?  120 : 0 ) + 'px'
        const withImageCol = colNum >= 3 ? 5 : colNum === 2 ? 4 : 3
        const top = () =>  (
            <div className={'grid'} style={{height: secondaryField ? '100px' : '50px'}}>
                <div className={` col-${12 - (useImage ? withImageCol : 0)}`} style={{overflow:'none'}}>
                    {render(env, primaryField, record, 'primary',renderOpts)}
                    {render(env, secondaryField, record, 'secondary',renderOpts)}
                </div>
                {useImage ? (
                    <div className={`col-${withImageCol} flex justify-content-end`}>
                        <Image preview={true} template={<i className={'pi pi-search-plus'}/>} alt="Image" src={image} height={secondaryField ? '85px' : '40px'} width={'100%'} style={{objectFit: 'cover'}}/>
                    </div>
                ) : ''}
            </div>
        )
        return (
            <div className={`${(highlight && selected) ? 'bg-yellow-100' : ''} border-round ${selected ? 'border-2 border-solid' : 'border-1 border-dotted'}`} style={{position: 'relative',height: cardHeightUse, padding: 10}}
            >
                {selected ? <Avatar icon="pi pi-check" className="mr-2 p-dialog-title" style={{ zIndex: 100, backgroundColor: 'rgb(233, 238, 249)', position: 'absolute', right: '-15px', top: '-5px' }} shape="circle" /> : ''}
                {top()}
                {subFields.length ? (<div className="flex card-container gap-3" style={{width: "100%", height: '80px', overflowX: 'auto', overflowY: 'hidden'}}>
                    {subFields.map((subField) => (
                        <>{render(env, subField, record, 'sub',renderOpts)}</>
                    ) )}
                </div>) : ''}
            </div>

        )
    }
    if(_.isString(record)){
        return (
            <p>{record}</p>
        )
    }
    return (
        <div key={record.tableRecordId} style={{cursor: onClick ? 'pointer' : undefined}} className={`col-${colNum} ${(highlight && selected && layout === 'list') ? '' : ''}`} onClick={() => {if(onClick)onClick(record)} }>

                {renderCard()}

            {/*{wrap( <><div className={cls.recordListItem}>*/}
            {/*    {showImage && image && <img src={image} style={{ height: '80px', paddingRight: '10px' }} />}*/}
            {/*    <div className={cls.recordListDetail}>*/}
            {/*        {render(env, primaryField, record, 'primary',renderOpts)}*/}
            {/*        {render(env, secondaryField, record, 'secondary',renderOpts)}*/}
            {/*    </div>*/}
            {/*    {showButton && <div className={cls.recordListAction} style={{alignSelf: 'baseline'}}>*/}
            {/*        <Button icon={`pi pi-${selected ? 'times' : 'check'}`} label={selected ? "Undo" : "Select"} onClick={() => onClick && onClick(record)} className={`p-button-sm ${selected ? "p-button-secondary" : "p-button-primary"}`} />*/}
            {/*    </div>}*/}
            {/*    {showClear && selected && <div className={cls.recordListAction} style={{alignSelf: 'baseline'}}>*/}
            {/*        <Button icon={`pi pi-times`} label={'Remove'} onClick={() => onClear && onClear(record)} className={"p-button-sm p-button-danger"} />*/}
            {/*    </div>}*/}
            {/*</div>*/}
            {/*    <div className="card">*/}
            {/*        <div className="flex flex-wrap card-container gap-3" style={{width: "100%"}}>*/}
            {/*            {subFields.map((subField) => (*/}
            {/*                <>{render(env, subField, record, 'sub',renderOpts)}</>*/}
            {/*            ) )}*/}


            {/*        </div>*/}
            {/*    </div></> )}*/}
        </div>
    )
}
export const renderTemplate = (template, data, config):{output:string, value:any} => {
    const options = extract( {format_as: 'markdown', render_as: 'markdown'}, config )
    const {output, error} = convertTemplate({template,data,...options})
    console.log("REndering Template", output, template, data, options)
    return {output, value: renderValue( output, options )}
}

const SCRIPTS_ADDED = {}
export const parseHtml = (html, options:any = {}) => {
    options = {target:true,sandbox:true,script:false,...options}
    const tags = []
    const attrs = []
    if(options.frame)tags.push('iframe')
    if(options.script){
        tags.push('script')
        attrs.push('async')
    }
    if(options.target)attrs.push('target')
    let clean = DOMPurify.sanitize(html, {ADD_TAGS: tags, ADD_ATTR: attrs})
    if(options.frame && options.sandbox)clean = clean.replace(/<iframe /g, '<iframe sandbox="allow-same-origin allow-scripts allow-popups allow-forms" ')
    console.log("Parsed Sanitized HTML", html ,clean, options)
    return parse(clean, {
        replace: function(domNode:any) {
            if (domNode.type === 'script' && options.script && !SCRIPTS_ADDED[domNode.attribs.src]) {
                const script = document.createElement('script');
                script.src = domNode.attribs.src;
                script.async = domNode.attribs.async;
                script.onload = function() {
                    console.log('***Script Tag Added**',  script.src);
                };
                document.head.appendChild(script);
                SCRIPTS_ADDED[domNode.attribs.src] = true
            }
        }
    })
}
export const renderValue = (element, config:any = {}) => {
    let {render_as, format_as, sep = ",", key_path = null} = config
    if(!render_as)render_as = ['markdown','button','collaborator'].includes(format_as) ? format_as : 'html'
    if (render_as === 'markdown') {
        switch(format_as){
            case 'url': {
                const {url, label} = parseUrlLabel(element)
                element = `[${label}](${url})`
                break;
            }
        }
        element = convertMDToHTML(`${toString(element,sep,key_path)}`)
        if(element.includes('on2air.com'))console.log("**RENDER VALUE**", element)
        return parseHtml( element, config.html || {} )
    }else if(format_as === 'button' && _.isObject(element as any)){
        return <Button onClick={openUrl(element.url, config.location, true)} label={element.label} style={toStyle(config.style || '')} className={config.classes || ''}/>

    }else if(['frame','iframe'].includes(render_as)){
        let elemUrl = _.isObject(element as any ) ? element.url : element
        if(!elemUrl?.startsWith('http')) {
            elemUrl = `https://${elemUrl}`
        }
        const asEmbed = convertFrameEmbed(elemUrl, config)
        if(asEmbed){
            return parseHtml( asEmbed, {script:true, ...(config.html || {})} )
        }
        return <iframe src={elemUrl} width={config.width || '100%'} height={(config.height || 500) + 'px'}
                       style={{border: 0, ...(config.style || {})}}/>
    } else if(format_as === 'collaborator' && _.isObject(element as any)){
        const collab = renderCollabOpt(element, _.get(config, 'collab_display', {}))
        return <>{collab}</>

    }else if(render_as === 'html' || _.isString(element)){
        switch(format_as){
            case 'url': {
                const {url, label} = parseUrlLabel(element)
                element = `<a href="${url}" target="_blank" rel="noreferrer nofollow">${label}</a>`
                break;
            }
            case 'button':
                return <Button onClick={openUrl(element, config.location,true)} label={'OPEN'}/>
        }

        return parseHtml( toBreaks(`${toString(element, sep, key_path)}`), config.html || {} )
    }else if(element){
        console.log('What is this to Render?', element, format_as, render_as)
    }
    return element
}

export const toDim = (val, def) => {
    if(!val)val = `${def}`
    if(_.isNumber(val))val = `${val}px`
    if(!val.includes('%') && !val.includes('px'))val += 'px'
    return val
}

export const convertFrameEmbed = (url, config) => {

    if(_.isString(url) && url.startsWith('http')){
        const width = toDim(config.width, '100%')
        const height = toDim(config.height, 500)
        const maps = [
            {
                regex: [/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/ , /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([a-zA-Z0-9_-]{11})/],
                embed: `<iframe width="${width}" height="${height}" src="https://www.youtube.com/embed/[1]" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
            },
            {
                regex: [/(?:https?:\/\/)?(?:www\.)?instagram\.com\/(p|reel|stories\/highlights)\/([a-zA-Z0-9-_]+)/],
                embed: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/reel/Cq5dRdsOBoo/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/reel/Cq5dRdsOBoo/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="https://www.instagram.com/reel/Cq5dRdsOBoo/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">A post shared by Good News Movement (@goodnews_movement)</a></p></div></blockquote> <script async src="//www.instagram.com/embed.js"></script>`,
                embedx: `<blockquote className="instagram-media" data-instgrm-captioned data-instgrm-permalink="https://www.instagram.com/[1]/[2]/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:${config.width}; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/[1]/[2]/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="https://www.instagram.com/[1]/[2]/?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">View Post</a></p></div></blockquote> <script async src="//www.instagram.com/embed.js"></script>`
            },
            {
                regex: [/(?:https?:\/\/)?(?:www\.)?facebook\.com/],
                embed: `<iframe src="https://www.facebook.com/plugins/post.php?href=[url]&show_text=true&width=${width}" width="${width}" height="${height}" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>`
            },
            {
                regex: [/(?:https?:\/\/)?(?:www\.)?twitter\.com\/(\w+)\/status\/(\d+)/],
                embed: `<blockquote class="twitter-tweet"><a href="[url]"></a></blockquote><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>`
            },
            {
                regex: [/(?:https?:\/\/)?(?:www\.)?linkedin\.com\/feed\/update\/urn:li:activity:(\d+)/],
                embed: `<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:share:[1]" height="${height}" width="${width}" frameborder="0" allowfullscreen="" title="Embedded post"></iframe>`
            },
            {
                regex: [/(?:https?:\/\/)?(?:www\.)?loom\.com\/share\/([a-zA-Z0-9]{32})/],
                embed: `<iframe src="https://www.loom.com/embed/[1]" height="${height}" width="${width}" frameborder="0" allowfullscreen="" title="Embedded loom"></iframe>`
            }

        ]
        for(let map of maps){
            for(let reg of map.regex) {
                const match = url.match(reg);
                if (match) {
                    let out = map.embed.replace(new RegExp(/\[url\]/, 'g'),url)
                    for (let index = 0; index < match.length; index++) {
                        out = out.replace(new RegExp("\\[" + index + "\\]", 'g'), match[index])
                    }
                    console.log("**FrameExtract**", {url,out,match})
                    return out
                }
            }
        }

    }
    return null
}

export const visibleDim = () => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
    return [vw,vh]
}
export const formatDuration = (value, format) => {
    if(!value)return ''
    if(!format)format = "h:mm"
    let seconds = Math.floor(Number(`${value}` ));
    let minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const millis = Math.floor((value - seconds) * 1000);
    seconds = seconds % 60;
    minutes = minutes % 60;
    value = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`
    if(format.includes(':ss')){
        value += `:${seconds < 10 ? '0' : ''}${seconds}`
        if(format.includes('.sss')){
            value += `.${millis < 10 ? '00' : millis < 100 ? '0' : ''}${millis}`
        }else if(format.includes('.ss')){
            value += `.${millis < 10 ? '0' : ''}${Math.ceil(millis / 10)}`
        }else if(format.includes('.s')){
            value += `.${millis < 10 ? '00' : millis < 100 ? '0' : ''}${Math.ceil(millis / 100)}`
        }
    }
    return value
    // const convertBack = (e) => {
    //     //not used
    //     const [hours,minutes,remainder = ''] = (e.target.value || '').split(':')
    //     const [seconds, millis] = remainder.split('.')
    //     let total = Number(seconds) + 0
    //     total += ( Number(minutes) + 0) * 60
    //     total += ( Number(hours) + 0) * 60 * 60
    //     if(millis)total += (Number(millis) + 0) / 1000
    //     helpers.setValue(total)
    // }
}
export const parseDate = (date) => {
    if(_.isDate(date))return parseDate(date.toISOString())
    let partDate = ''
    let partTime = ''
    if(date.includes('T')){
        let parts = date.split("T",2)
        return parts
    }else if(date.includes(',') || date.includes(' ')){
        const d = new Date(date)
        return parseDate(d.toISOString())
    }else{
     return [date,'']
    }

}
export const toISO = (date, tz_mode, withTime = true) => {
    if(date && _.isString(date)) {
        const dLow = date.toLowerCase()
        const cy = (elem) => elem.length ? elem.length > 2 ? elem : '20' + elem : new Date().getFullYear()
        let nowDate = DateTime.local()
        if(withTime) {
            if (tz_mode === 'utc') {
                nowDate = DateTime.utc()
            } else if (tz_mode && tz_mode !== 'local') {
                nowDate = DateTime.fromObject({}, {zone: tz_mode})
            }
        }
        const cp = (elem, emptyVal: string | number = '00') => elem.length ? elem.length > 1 ? elem : '0' + elem : cp(`${emptyVal}`)
        if(dLow === 'now()')date = nowDate.toISO()
        else if(dLow === 'today()'){
            date = nowDate.toISO().split('T')[0]
            console.log('Getting Today', date, nowDate, nowDate.toISO(), nowDate.toISO().split('T'))
        }

        let [partDate, partTime = ''] = parseDate(date)
        if (partDate.includes('/')) {
            const [partMonth, partDay, partYear] = partDate.split("/")
            partDate = `${cy(partYear)}-${cp(partMonth, new Date().getUTCMonth())}-${cp(partDay, '01')}`
        }
        let [partTimeLeft, partTimeRight = ''] = partTime.split('+')
        if (!partTimeLeft) partTimeLeft = "12:00:00"
        if (tz_mode === 'utc' && !partTimeRight) partTimeRight = "0000"
        let [partHour = '', partMin = '', partSec = ''] = partTimeLeft.split(":")
        partTime = `${cp(partHour, new Date().getUTCHours())}:${cp(partMin, new Date().getUTCMonth())}:${cp(partSec)}${partTimeRight ? `+${partTimeRight}` : ''}`
        const out = DateTime.fromISO(`${partDate}${withTime ? `T${partTime}` : ''}`, withTime && tz_mode ? {zone:tz_mode} : {})
        console.log("Parsed Date", {withTime, date, dLow, out, partDate, partTime, tz_mode})
        return withTime ? out.toISO() : out.toISODate()
    }
    return date
}
export const toDateRel = (days, subtract = false) => {
    if(![undefined,null,''].includes(days)){
        const now = new Date()
        days = Number(`${days}`)
        const curr = now.getDate()
        now.setDate(subtract ? curr - days : curr + days)
        return now
    }
    return null
}
export const toDate = (date, options = {}, asDateTime = false) => {
    const ori = date
    const useOptions:any = { ...options}
    if(date) {

        if (_.isString(date) && date) {
            const zone = useOptions.time ? (useOptions.tz_mode === 'custom' ? (useOptions.tz || useOptions.options?.timeZone) : useOptions.tz_mode) : ''
            const iso = toISO(date, zone, useOptions.time)
            const dt = DateTime.fromISO(iso, zone ? {zone} : {})
            if(asDateTime)return dt
            date = dt.toJSDate()
            console.log('**converted toDate**', {dt,date,iso,zone,ori})
        } else if (_.isNumber(date)) {
            date = new Date(date)
        }
    }
    console.log('toDate', ori, date, useOptions)
    return asDateTime ? DateTime.fromJSDate(date) : date
}
export const DATE_FORMATS = (incTime, addSecs = false) => ({
    local: incTime ? (addSecs ? DateTime.DATETIME_SHORT_WITH_SECONDS : DateTime.DATETIME_SHORT) : DateTime.DATE_SHORT,
    us: incTime ? (addSecs ? DateTime.DATETIME_SHORT_WITH_SECONDS : DateTime.DATETIME_SHORT) : DateTime.DATE_SHORT,
    friendly: incTime ? (addSecs ? DateTime.DATETIME_MED_WITH_SECONDS : DateTime.DATETIME_MED ) : DateTime.DATE_MED,
    european: incTime ? (addSecs ? DateTime.DATETIME_SHORT_WITH_SECONDS : DateTime.DATETIME_SHORT) : DateTime.DATE_SHORT,
    short: incTime ? (addSecs ? DateTime.DATETIME_SHORT_WITH_SECONDS : DateTime.DATETIME_SHORT) : DateTime.DATE_SHORT,
    med: incTime ? (addSecs ? DateTime.DATETIME_MED_WITH_SECONDS : DateTime.DATETIME_MED ) : DateTime.DATE_MED,
    full: incTime ? (addSecs ? DateTime.DATETIME_FULL_WITH_SECONDS : DateTime.DATETIME_FULL ) : DateTime.DATE_FULL,
    huge: incTime ? (addSecs ? DateTime.DATETIME_HUGE_WITH_SECONDS : DateTime.DATETIME_HUGE ) : DateTime.DATE_HUGE,
})
export const convertAtFormat = (isTime, dateOptions) => {
    let format = 'D'//dateOptions?.dateFormat ||
    if(isTime){
        format += ' t'//dateOptions?.timeFormat ||
    }
    return format
}
export const toDateFormat = (key:string, incTime:boolean, extras:any = {}) => extract(['weekday', 'year', 'month', 'day', ...(incTime ? ['hour','minute','second','hour12', 'timeZoneName'] : [])], {...(_.get(DATE_FORMATS(incTime, extras.addSecs), key.toLowerCase())), ...extras, ...(extras.hour24 ? {hour12: false} : {})})
export const toDateText = (date, options) => {
    if(!date)return date
    let text = ''
    const {time = false, tz_mode = '', tz = '', format_mode, format, locale} = options
    let dt = toDate(date, options, true)
    if(locale)dt = dt.setLocale(locale)
    if(time) {
        if (tz_mode === 'utc') {
            dt = dt.toUTC()
        } else if (tz_mode === 'custom' && (tz || options.options?.timeZone)) {
            dt = dt.setZone(tz || options.options?.timeZone)
        } else {//local

        }
    }
    if(format_mode === 'custom'){
        text = dt.toFormat(format || convertAtFormat(time, options.options))
    }else if(format_mode === 'iso') {
        text = time ? dt.toISO() : dt.toISODate()
    }else{
        const useFormat = toDateFormat(format_mode || 'short', time, options)
        text = dt.toLocaleString(useFormat)
        console.log('Formatted Date', format_mode, useFormat, text, date, dt, tz, time, options)
    }

    return text
}

export const formatNumber = ( value, format, locale = null, zeroFormat = null, nullFormat = null) => {
    if([null,undefined,'',false,'no','off'].includes(value)) value = 0
    if([true,'yes','on'].includes(value)) value = 1
    if((value || value === 0)) {
        if (locale) numeral.locale(locale)
        if (zeroFormat) numeral.zeroFormat(zeroFormat)
        if (nullFormat) numeral.nullFormat(nullFormat)
        const num = numeral(value)
        console.log('Formatting Number', value, num, format, locale)
        return num.format(format)
    }
    return value
}

export const toGroups = ( items, grouping ) => {
    let output = items
    if(grouping){
        if(_.isString(grouping))grouping = {field:grouping}
        output = {}
        let {field:groupField, sort:groupSort, order:groupOrder, max: groupMax, label:groupLabel, spread: groupSpread = false, style={}, separator='', page_break='',sep_style={}} = grouping
        if(!_.isObject(groupSort))groupSort = {field: groupSort, order: groupOrder || 'asc'}

        const processRecord = (rec, groupByVal) => {
            if(Array.isArray(groupByVal))groupByVal = groupByVal.join(",")
            if(!_.has(output,groupByVal)){
                //logger.info({msg:'Adding Group', separator, grouping})
                output[groupByVal] = {
                    sort: groupSort?.field !== true ? _.get(rec, groupSort?.field) : groupByVal,
                    style,
                    separator: separator || '',
                    sep_style,
                    page_break: !!page_break,
                    label: groupLabel === false ? "" : (!groupLabel || groupLabel === true ? groupByVal : _.get(rec,groupLabel, groupLabel)),
                    items: []
                }
            }
            output[groupByVal].items.push(rec)
        }
        for(let rec of items){
            let groupByVal = _.get( rec, groupField )

            if(groupSpread && Array.isArray(groupByVal)){
                for(let gbv of groupByVal){
                    processRecord( rec, gbv )
                }
            }else{
                processRecord( rec, groupByVal )
            }

        }
        output = Object.values(output)
        if(groupSort?.field){

            // logger.info({msg:'Sorting Groups', groupSort, groupOrder, grouping, before: output.map( g => g.sort)})
            output = output.sort( (gA, gB) => {
                let valA = _.get(gA,'sort')
                let valB = _.get(gB,'sort')
                if( _.isNumber(valA) && _.isNumber(valB) ){
                    let diff = valA - valB
                    return groupSort?.order === 'desc' ? ( diff * -1 ) : diff
                }else if( _.isDate(valA) && _.isDate(valB)){
                    let diff = valA.getTime() - valB.getTime()
                    return groupSort?.order === 'desc' ? ( diff * -1 ) : diff

                }else{
                    let diff = `${valA}`.localeCompare(`${valB}`, undefined, {sensitivity: 'accent'})
                    return groupSort?.order === 'desc' ? ( diff * -1 ) : diff
                }
            })
            // logger.info({msg:'Sorting Groups', groupSort, groupOrder, after: output.map( g => g.sort)})
        }
        if(groupMax){
            output = output.map( g => {
                g.items = g.items.slice(0, groupMax)
            })
        }
    }
    return output
}
export const fieldValAsString = ( value, join = ",") => {
    if(_.isArray(value)){
        value = value.map( item => fieldValAsString(item, join) ).join(join)
    }else if(_.isObject(value)){
        const paths = ['filename','label','text','url','name','id']
        for(let path of paths){
            if(_.has(value,path)){
                value = _.get(value,path)
                break;
            }
        }
    }else if([undefined,null].includes(value)){
        value = ''
    }
    return `${value}`
}
export const matchRecordField = (query, record, field) => {
    if(field.name === true){
        if(_.has(record,'Name'))return matchRecordField( query, record, {...field, name: 'Name'})
        let keys = Object.keys(record)
        for(let key of keys){
            if(!['tableRecordId','recordCreatedTime'].includes(key)){
                //do first field only
                return matchRecordField( query, record, {...field, name: key})
            }
        }
        return false
    }
    query = fieldValAsString(query)
    const lowerQuery = `${query}`.toLowerCase()

    let sfVal = _.get(record, field.name )
    let sfValStrFull = fieldValAsString(sfVal)
    let sfValStrLower = sfValStrFull.toLowerCase()
    let sfMode = field.search_mode || 'contains'
    let sfCase = field.search_case || false
    let qVal = _.trim(_.deburr(sfCase ? query : lowerQuery))
    let sfValStr = _.trim(_.deburr(sfCase ? sfValStrFull : sfValStrLower))
    let sfAcceptEmpty = !field.search_require_query
    if(!qVal && sfAcceptEmpty)return true
    console.log('Query Match', qVal, !qVal, sfAcceptEmpty, sfValStr, sfMode, field, record )
    if(sfMode === 'exact'){
        if(sfValStr === qVal)return true
    }else if(sfMode === 'contains'){
        if(sfValStr.includes(qVal))return true
    }else if(sfMode === 'starts_with'){
        if(sfValStr.startsWith(qVal))return true
    }else if(sfMode === 'ends_with'){
        if(sfValStr.endsWith(qVal))return true
    }else if(sfMode === 'not_exact'){
        if(sfValStr !== qVal)return true
    }else if(sfMode === 'not_contains'){
        if(!sfValStr.includes(qVal))return true
    }else if(sfMode === 'contained'){
        if(qVal.includes(sfValStr))return true
    }else if(sfMode === 'not_contained'){
        if(!qVal.includes(sfValStr))return true
    }else if(sfMode === 'contains_either'){
        if(sfValStr.includes(qVal) || qVal.includes(sfValStr))return true
    }else if(sfMode === 'not_contains_either'){
        if(!sfValStr.includes(qVal) && !qVal.includes(sfValStr))return true
    }else{
        return true
    }



    return false
}
export const isDisplayStatus = (dField,dStatus) => wrapArray(dStatus).includes(_.isObject(dField as any) ? dField.display_status : dField)

export const getParentValue = (paths, store, path, field) => {
    const index = 1 + (path.match(/parent\./g) || []).length
    const key = paths[paths.length - index]
    const parentValues = storeFormData(store, key)
    const parentFieldValue = field === true ? null : parentValues[field]
    return [index,key,parentValues,parentFieldValue]

}

export const isDisplayMode = (dField,dMode, negate = false) => {
    const result = wrapArray(dMode).includes( _.isObject(dField as any) ? dField.display?.mode : dField )
    return negate ? !result : result
}
export const flatArray = (items, split:string|boolean = false) => {
    let out = []
    items = wrapArray(items,split)
    for(let item of items){
        if(Array.isArray(item)){
            out = out.concat( flatArray(item,split) )
        }else{
            out.push(item)
        }
    }
    return out
}
export const wrapArray = (item, split:string|boolean = false) => {
    if(_.isArray(item))return item
    if([null,undefined,''].includes(item)) return []
    if(split && _.isString(item)){
        const items = item.trim().split(split === true ? "," : split).filter(_.trim).map(_.trim)
        return items
    }
    return [item]
}
export const isEditingRecord = (formId) => isRecId(formId)
export const isCreatingRecord = (formId) => !isRecId(formId)
export const getFormData = (store, recId, insertId = true) => {
    if(Array.isArray(recId))return recId.map( rId => getFormData(store,rId) )
    const formData = _.get(store.formData.data, `${recId}.data`) || {}
    return insertId ? {...formData, tableRecordId: recId} : formData
}

export const insertRecordFormData = (formId, record, store: AppState, expandLinkedRecords = false, asString = false) => {
    if(!record && !formId)return record
    if(_.isArray(record))return record.map( rec => insertRecordFormData(formId, rec, store, expandLinkedRecords, asString) )
    if(!_.isObject(record)){
        record = {tableRecordId: record}
    }
    const recId = record?.tableRecordId
    if(!recId && !formId)return recId

    let iterEntity = isRecId(recId) ? 'record' : 'form'
    const modified = _.cloneDeep({...record})
    const formData = _.get(store.formData.data, `${formId || recId}.data`) || {}
    const fields = _.get(store.formPage.data, `${formId || recId}.details.fields`) || []
    console.log('Inserting Record Form Data', {recId, iterEntity, record, formData, fields, modified,expandLinkedRecords})

    if(fields.length && !_.isEmpty(formData)) {
        _.each(formData, (val, key) => {
            const field = fields.find(f => f['id'] === key)
            if (field) {
                console.log('Inserting Record Field', {field,key,val})
                let fieldVal = '' as any
                if(expandLinkedRecords && field.type === FieldTypes.FT_RECORD_LINKS){
                    fieldVal = wrapArray(formData[field.id]).map( fd => insertRecordFormData( fd.tableRecordId, fd, store, false, asString ) )
                }else{
                    fieldVal = asString ? toString(formData[field.id]) : formData[field.id]
                }
                if(!_.has(modified, field.id))modified[field.id] = fieldVal
                if(!_.has(modified, field.name))modified[field.name] = fieldVal
            }
        })
    }
    return modified
}


export const insertGridsState = ( formId, grid, store ) => {
    const modified = _.defaults( _.cloneDeep(store.formData.data[`${formId}_grid`]?.data || {}), store.formData.data['grid']?.data || {}, grid || {}  )
    modified['blocks'] = (modified.blocks || []).map( block => _.defaults( _.cloneDeep(store.formData.data[block.id]?.data || {}), store.formData.data['blocks']?.data || {}, block ))
    return modified
}
export const insertFieldsState = ( fields, store ) => fields.map( field => insertFieldState(field, store ) )
export const insertFieldState = ( fieldConfig, store ) => {
    const {id} = fieldConfig
    const modified = _.defaults( _.cloneDeep(store.formData.data[id]?.data || {}), store.formData.data['fields']?.data || {}, fieldConfig )
    if(store.formData.data[id]?.data){
        console.log('[insertFieldState]',id,{fieldConfig,store:store.formData.data[id]?.data,modified})
    }
    return modified
}
const _isId = (id, start ) => id && id.startsWith(start)
export const isRecId = id => _isId( id, 'rec')
export const isFieldId = id => _isId( id, 'fld')
export const isTableId = id => _isId( id, 'tbl')
export const isBaseId = id => _isId( id, 'app')
export const isViewId = id => _isId( id, 'viw')

export const toIcon = icon => {
    if(icon){
        icon = icon.trim()
        if(icon.startsWith('pi-'))icon = `pi ${icon}`
        else if(!icon.startsWith('pi pi-'))icon = `pi pi-${icon}`
        else if(!icon.startsWith('pi '))icon = `pi ${icon}`
    }
    return icon
}
export const findOne = ( val, paths ) => {
    for(let path of paths){
        if(_.has(val,path))return _.get(val,path)
    }
    return null
}
export const toBreaks = (val:string) => `${val}`.replace(new RegExp('\\\\n', 'g'), '<br/>').replace(new RegExp("\n", 'g'), '<br/>')
export const toOptions = ( val:any ) => {
    return wrapArray(val).map( v => {
        return extract({value:_.isObject(v as any) ? v.id : undefined,label:_.isObject(v as any) ? v.name : undefined,color:undefined}, _.isPlainObject(v) ? v : {}, _.isPlainObject(v) ? v : {})
    })
}
export const replaceFieldIds = (text:string, fields:any[]) => {
    for(let field of fields) {
        text = errMsgReplace(text, field, field.label, field.id)//`${text}`.replace(new RegExp(field.id, 'g'), field.label || field.name as string)
    }
    return text
}
export const toStyleString = (style = {}) => {
    return _.isObject(style) ? Object.keys(style).reduce((acc, key) => (
        acc + key.split(/(?=[A-Z])/).join('-').toLowerCase() + ':' + style[key] + ';'
    ), '') : '';
}
export const toStyle = (val, defaults = {}, overrides = {}) => {
    let css = {}
    try{
        css = _.isObject(val) ? val : parseCss( val || '')
    }catch(err){
        console.log('Error on Style Parse', val, err.message)
    }
    return {...defaults, ...css, ...overrides}
}
export const toString = ( val:any, sep = ",", finderPath = null) => {
    if(_.isArray(val))return val.map( v => toString(v, sep, finderPath) ).join(sep)
    if(_.isDate(val))val = val.toISOString()
    if(_.isObject(val)){
        val = findOne( val, wrapArray(finderPath).concat(['__','url','value','name','email','id']))
    }
    return [null,undefined].includes(val) ? '' : `${val}`
}
export const toBool = ( val:string|boolean|number, defaultVal = false) => {
    if(Array.isArray(val))return val.map(v => toBool(v, defaultVal) )
    if(_.isString(val))val = val.toLowerCase()
    if(val === true || val === 1 || val === "1"  || val == "checked" || val === "true" || val === "yes" || val === "on")return true
    else if(val === false || val === 0 || val === "0"|| val == "unchecked"  || val === "false" || val === "no" || val === "off")return false
    else return defaultVal
}

export const openUrl = ( url, location, asOnClick = false ) => {
    const doOpen = () => {
        const isSame = ['self','same','top'].includes(location)
        console.log('Opening URL', {url,isSame,location})
        if(isSame){
            (location === 'top' ? window.top : window).location.href = url
        }else{
            if(`${location || ''}`.startsWith('popup')){
                const [p,features='popup'] = location.split(':',2)
                console.log('Opening as popup', features)
                window.open(url,'popup-' + Date.now(), features)
            }else {
                window.open(url, '_blank')
            }
        }
    }
    if(asOnClick)return doOpen
    doOpen()
}

export const toGridRows = ( grid, fields ) => {
    const blocks = (grid.blocks || []).filter( block => _.has(block,'x') && _.has(block,'y'))
    const cols = grid.options?.numCols || 1
    let max = 0
    blocks.forEach( block => max = Math.max( max, block.y || 0))
    const rows = Array.from(Array(max+1)).map( () => Array.from(Array(cols).map(() => null as any) ) )

    blocks.forEach( block => rows[block.y][block.x] = ({
        block, fields: fields.filter( field => block.fields.includes(field.id)).sort( (a,b) => block.fields.indexOf(a.id) - block.fields.indexOf(b.id) ),
        col: determineCols(block.w, cols)
    }))
    const prepRow = (row: any[]) => {
        // console.log('PREP ROW BEFORE', row)
        let colsUsed = 0
        for(let i=0; i<row.length; i++){
            if(!row[i]){
                if(colsUsed < cols) {
                    row[i] = {
                        block: null, fields: [], col: determineCols(1, cols)
                    }
                    colsUsed++
                }
            }else{
                colsUsed += row[i].block.w
            }
        }
        // console.log('PREP ROW AFTER', row)
        return row
    }
    return rows.filter( row => row.find( cell => !!cell) )
        .map(prepRow)
}
export const determineCols = (usedCols, numCols) => {
    const lg = Math.floor(12 / numCols) * (usedCols || 1)
    const md = Math.min(12, lg * 2)
    const sm = 12
    return {lg, md, sm}
}

export const getItemNames = (config, defaultSingle, defaultPlural = '') => {
    let {singular, plural} = config || {}
    if(!singular)singular = defaultSingle
    if(!plural)plural = defaultPlural || `${singular}s`
    return {singular,plural}
}
export const addCollabOptions = (field) => {
    const {details = {}, extraConfig = {}} = field
    const {collabs = []} = details
    const choices = collabOptions(collabs, extraConfig)
    if(choices.length) {
        const withCollab = {...field}
        withCollab.extraConfig.keyLabel = 'label'
        withCollab.extraConfig.keyValue = 'id'
        withCollab.extraConfig.as_chip = false
        if (!withCollab.extraConfig.options) withCollab.extraConfig.options = {}
        if (!withCollab.extraConfig.options.choices) withCollab.extraConfig.options.choices = choices
        return withCollab
    }
    return field
}
export const findCollab = (all:Collab[], one:Collab|string|null):Collab => {
    const match = one ? (
        all.find( a => [a.id,a.name,a.email].includes(_.isObject(one) ? (one.id || one.email || one.name) : one)) || (_.isObject(one) ? one : one.includes('@') ? {email:one} : {name:one} )
    ) : one
    return match as Collab
}
export const collabOptions = (collabs:Collab[], config) => collabs.map( col => ({...col, label: renderCollabOpt(col, config)}))
export const renderCollabOpt = (collab:Collab, config) =>  {
    const showPic = _.get(config, 'show.pic', true)
    const picSize = _.get(config, 'show.picSize', 25)
    const showName = _.get(config, 'show.name', true)
    const showEmail = _.get(config, 'show.email', true)
    const out = collab.name ? (
        <div className={"flex justify-content-start"}>
            {showPic && collab.profilePicUrl && <div className={"flex"}><img src={collab.profilePicUrl} width={picSize} height={picSize}/></div>}
            {showName && collab.name && <div className={"flex ml-1"}><strong>{collab.name}</strong></div>}
            {showEmail && collab.email && <div className={"flex ml-1"}>{showName && '('}{collab.email}{showName && ')'}</div>}
        </div>
    ) : collab.id || ''

    return out
}


export const tableFieldFilter = (field) => {
    let filter:any = { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
    const defs = fieldDefaultConfig('table',field.type, field.options)
    return defs.table?.filter.op || filter
}

export const tableFieldConfig = (field,config) => {
    const {table} = fieldDefaultConfig('table',field.type, field.options, config)
    console.log('**tableFieldConfig**', {table:JSON.stringify(table),config})
    table.sortable = table.sortable && config.sortable
    table.filter = table.filter && config.filter
    return table
}
export const tableFieldValFunc = (field,converted,save,toVal) => (item) => {
    const path = `${item.tableRecordId}.${field.id}`
    let val = _.get(converted,path)
    if(val === undefined){
        val = toVal(item)
        _.set(converted,path,val)
        save(converted)
    }
    return val
}


export const isNum = (check, convertEmpty0 = true, justNum = false) =>{
    const result:any = {valid:false,ori:check,value:null}
    try {
        if (convertEmpty0 && [null, undefined, ''].includes(check)) check = 0
        if(_.isNumber(check)){
            result.valid = true
            result.value = check
        }else if(check && !isNaN(check)){
            result.valid = true
            result.value = Number(check)
        }
    }catch(ignore){}
    return justNum ? result.value : result
}
export const compNum = (first,second) => {
    const isFirst = isNum(first)
    const isSecond = isNum(second)
    if(isFirst.valid && isSecond.valid){
        return {valid:true,value: isFirst.value - isSecond.value}
    }
    return {valid:false}
}
export const isDate = (check, justDate = false) => {
    const result:any = {valid:false,ori:check,value:null}
    const doRet = () => justDate ? result.value : result
    if(!check)return doRet()
    if(_.isDate(check)){
        result.valid = true
        result.value = check
        return doRet()
    }
    try {
        const date = new Date(check)
        if(date.toString() !== 'Invalid Date'){
            result.valid = true
            result.value = date
        }
    }catch(ignore){}
    return doRet()
}
export const compDate = (first,second) => {
    const isFirst = isDate(first)
    const isSecond = isDate(second)
    if(isFirst.valid && isSecond.valid){
        return {valid:true,value: isFirst.value.getTime() - isSecond.value.getTime()}
    }
    return {valid:false}
}
export const tableFieldSortFunc = (toVal) => {
    return (event) => {
        console.log('**tableField - sort', {event})
        const sorted = event.data.sort( (a,b) => {
            const aVal = toVal(a)
            const bVal = toVal(b)
            let first = event.order > 0 ? aVal : bVal
            let second = event.order > 0 ? bVal : aVal
            console.log('**tableField - sort compare', {first,second,order:event.order})
            let out = compNum(first,second)
            if(out.valid)return out.value
            out = compDate(first,second)
            if(out.valid)return out.value

            return (first || '').localeCompare(second || '')

        })
        return sorted
    }
}

export const tableFieldFilterFunc = (toVal) => {

    return (value,filter,filterLocale,params) => {
        console.log('**tableField - filter', {value,filter,filterLocale,params})
        // const val = formatValueWithCustom()
    }
}

export const errMsgReplace = (errMsg, field, label, name) => {
    return `${errMsg}`.replace(new RegExp(name, 'g'), (field.title || label || field.name) as string)
                .replace(new RegExp(field.name, 'g'), (field.title || label || field.name) as string)
}